"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _usageTrackerCore = require("usage-tracker-core");

var _storageKeys = require("usage-tracker-core/storageKeys");

var _cookieHelper = require("./helpers/cookieHelper");

var _langHelper = require("./helpers/langHelper");

var _sendBeacon = _interopRequireDefault(require("./helpers/sendBeacon"));

var _reportError = _interopRequireDefault(require("./helpers/reportError"));

var tempStorage = _interopRequireWildcard(require("./containers/tempStorage"));

var hasBeaconSupport = navigator && typeof navigator.sendBeacon === 'function';
var suffix = _enviro.default.getShort() === 'qa' ? 'qa' : '';
var origin = "https://app.hubspot" + suffix + ".com";
var path = '/usage-logging/v1/log/hublytics-multi/no-auth';

var reportNetworkError = function reportNetworkError(err) {
  return (0, _reportError.default)(err, {
    fingerprint: ['usage-tracker-js', 'network']
  });
};

var getDebug = function getDebug() {
  return _enviro.default.debug(_storageKeys.debugKey);
};

var getTrackerHstc = function getTrackerHstc() {
  return new Promise(function (resolve) {
    /* eslint-disable */
    var interval;
    var timeout;
    interval = setInterval(function () {
      var hstc = (0, _cookieHelper.getHstc)();

      if (hstc) {
        clearTimeout(timeout);
        clearInterval(interval);
        resolve(hstc);
      }
    }, 100);
    timeout = setTimeout(function () {
      if (!(0, _cookieHelper.getHstc)()) {
        clearInterval(interval);

        if (_enviro.default.debug(_storageKeys.debugKey) && console && typeof console.warn === 'function') {
          console.warn('Could not get tracker hstc after 8 seconds');
        }

        resolve(null);
      }
    }, 8000);
  });
};

var PublicTrackingClient = (0, _usageTrackerCore.createClient)({
  clientName: 'public',
  getDebug: getDebug,
  getEmail: function getEmail() {
    return null;
  },
  getHubId: function getHubId() {
    return null;
  },
  getHstc: getTrackerHstc,
  getLang: function getLang() {
    return _langHelper.defaultLanguage;
  },
  getTempStorage: tempStorage.get,
  setTempStorage: tempStorage.set,
  logError: function logError(err) {
    if (getDebug()) {
      console.error(err);
    }
  },
  reportError: _reportError.default,
  send: function send(_ref) {
    var events = _ref.events,
        query = _ref.query,
        isBeforeUnload = _ref.isBeforeUnload;
    var endpoint = path + "?" + query;
    var data = events;

    var sendXhr = function sendXhr() {
      var promise = _noAuthApiClient.default.post(endpoint, {
        data: data
      }).catch(reportNetworkError);

      if (promise && typeof promise.done === 'function') {
        promise.done();
      }
    };

    if (isBeforeUnload && hasBeaconSupport) {
      (0, _sendBeacon.default)("" + origin + endpoint, data, sendXhr);
    } else {
      sendXhr();
    }
  }
});
var _default = PublicTrackingClient;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-public/static-1.338/js/PublicTrackingClient.js
// module id = 218
// module chunks = 0